import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import phoneimage from 'assets/images/Group.svg';
import { connect } from 'react-redux';
import useService from 'hooks/useService'
import { setProps } from 'redux/actions';
import { Config, IISMethods } from 'config/IISMethods'
import SuccessOverlay from 'view/Components/SuccessOverlay'
import Header from 'components/Header'
import useCongnito from 'hooks/useCongnito'


const VerifyOTP = (props) => {
    const navigate = useNavigate();
    const { API_Call } = useCongnito()
    const [showOtp, setShowOtp] = useState(false); // Control OTP visibility
    const [timer, setTimer] = useState("05:00");  // Initial 5 minutes
    const [showTimer, setShowTimer] = useState(false);
    const [otpValues, setOtpValues] = useState(['', '', '', '']); // State for OTP values
    const [isVerifying, setIsVerifying] = useState(false); // Track verification status
    const [errorMessage, setErrorMessage] = useState('');
    const [codesend, setCodesend] = useState(false)
    const timerRef = useRef(null);
    const errRef = useRef(null);
    const [success, setSuccess] = useState('');
    const otpInputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)]; // Refs for OTP inputs
    const { getStorageData, getURLData, setAllStorageData } = useService()
    const DigitalkeyData = getStorageData('digitalkeydata')
    const history = useNavigate()

    useEffect(() => {
        let digitalkeydata = IISMethods.getLocalData('DigitalkeyData')
        if (
            digitalkeydata?.[getURLData().defaultURL] === undefined ||
            (typeof digitalkeydata[getURLData().defaultURL] === 'object' && Object.keys(digitalkeydata[getURLData().defaultURL]).length === 0)
        ) {
            history(`/${getURLData().defaultURL}/linkexpired`)
        }
    }, [DigitalkeyData?.roomnoid])

    useEffect(() => {
        if (showOtp && otpInputRefs[0].current) {
            const focusAttempts = [100, 300, 500, 1000];
            focusAttempts.forEach(delay => {
                setTimeout(() => {
                    if (otpInputRefs[0].current) {
                        otpInputRefs[0].current.focus();
                        otpInputRefs[0].current.click();
                    }
                }, delay);
            });
        }
    }, [showOtp]);

    const getBrowserName = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isIOS = /iphone|ipad|ipod/.test(userAgent);
        if (userAgent.includes('edg')) {
            return 'Edge';
        } else if (userAgent.includes('firefox')) {
            return 'Firefox';
        } else if (userAgent.includes('chrome') && !userAgent.includes('edg') && !userAgent.includes('opr')) {
            if (isIOS) {
                return 'Chrome on iPhone';
            }
            return 'Chrome';
        } else if (userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('crios')) {
            if (isIOS) {
                return 'Safari on iPhone';
            }
            return 'Safari';
        } else if (userAgent.includes('crios')) {
            return 'Chrome on iPhone';
        } else {
            return 'Other';
        }
    }

    const startCountdown = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        setShowTimer(true);
        let minutes = 5;
        let seconds = 0;
        timerRef.current = setInterval(() => {
            if (minutes === 0 && seconds === 0) {
                clearInterval(timerRef.current);
                setShowTimer(false);
                return;
            }
            if (seconds === 0) {
                minutes--;
                seconds = 59;
            } else {
                seconds--;
            }
            setTimer(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }, 1000);
    };

    // Cleanup timer on component unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    // useEffect(() => {
    //     if (clipboardValue && clipboardValue.length === 4) {
    //         const digits = clipboardValue.replace(/\D/g, '').split('');
    //         console.log("🌟✨ BR >  ~ useEffect ~ digits:", digits)
    //         // setOtp(digits);
    //         alert(digits)
    //     }
    // }, [clipboardValue]);

    const handleOtpChange = async (index, value) => {
        try {
            errRef.current = `change - ${index}, ${value}`;
            let newOtpValues = [...otpValues];
            if (value.length === 4) {
                otpInputRefs[index].current.blur();
                newOtpValues = [...value.toString()];
                setOtpValues([...value.toString()]);
            }
            else if (value.length > 1) {
                let digits = value.replace(/\D/g, '').split('').slice(0, 4);
                digits.forEach((digit, i) => {
                    if (index + i < 4) {
                        newOtpValues[index + i] = digit;
                    }
                });
                setOtpValues(newOtpValues);
                let nextIndex = Math.min(index + digits.length, 3);
                if (otpInputRefs[nextIndex].current) {
                    otpInputRefs[nextIndex].current.focus();
                }
                // Auto-verify if we have 4 digits after pasting
                // if (digits.length === 4 && !isVerifying) {
                //     VerifyCode(props);
                // }
            }
            else if (value.length <= 1) {
                newOtpValues[index] = value;
                setOtpValues(newOtpValues);
                if (value.length === 1 && index < 3) {
                    let nextInput = otpInputRefs[index + 1].current;
                    if (nextInput) nextInput.focus();
                }
            }

            // For manual entry, check if all 4 digits are filledx
            if ((newOtpValues.every(val => val !== '') && newOtpValues.length === 4) || value.length === 4) {
                if (!window.verificationInProgress) {
                    window.verificationInProgress = true;
                    setTimeout(() => {
                        const verifyButton = document.getElementById('verify-button');
                        const browserName = getBrowserName();
                        if (verifyButton && browserName !== 'Safari on iPhone') {
                            verifyButton.click();
                        } else {
                            VerifyCode(props);
                        }
                        window.verificationInProgress = false;
                    }, 1);  // Adjust delay if needed
                }
            }
        } catch (err) {
            errRef.current = err.toString();
            alert('Error: ' + err.message);
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        let pastedData = '';
        try {
            pastedData = e.clipboardData.getData('text');
        } catch (err) {
            console.log('Standard clipboard access failed');
            try {
                pastedData = (e.clipboardData || window.clipboardData).getData('text/plain');
            } catch (err) {
                console.log('Alternative clipboard access failed');
            }
        }
        const digits = pastedData.replace(/\D/g, '').split('').slice(0, 4);
        if (digits.length > 0) {
            let newOtpValues = [];
            digits.forEach((digit, index) => {
                if (index < 4) {
                    newOtpValues[index] = digit;
                }
            });
            setOtpValues(newOtpValues);
            const lastFilledIndex = Math.min(digits.length - 1, 3);
            if (otpInputRefs[lastFilledIndex] && otpInputRefs[lastFilledIndex].current) {
                otpInputRefs[lastFilledIndex].current.focus();
            }
            if (digits.length === 4 && !isVerifying) {
                VerifyCode(props);
            }
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            const newOtpValues = [...otpValues];
            if (newOtpValues[index] === '' && index > 0) {
                newOtpValues[index - 1] = ''; // Clear previous input
                setOtpValues(newOtpValues);
                otpInputRefs[index - 1].current.focus();
            } else {
                newOtpValues[index] = '';
                setOtpValues(newOtpValues);
            }
        }
        if (e.key === 'Enter' && !isVerifying) {
            const isComplete = otpValues.every(value => value !== '');
            if (isComplete) {
                VerifyCode(props);
            }
        }
    };

    const handleResendClick = async () => {
        await CoudeSend();
        if (!showTimer) {
            startCountdown();
        }
        if (otpInputRefs[0].current) {
            const focusAttempts = [100, 300, 500, 1000];
            focusAttempts.forEach(delay => {
                setTimeout(() => {
                    if (otpInputRefs[0].current) {
                        otpInputRefs[0].current.focus();
                        otpInputRefs[0].current.click();
                    }
                }, delay);
            });
        }
    };

    const CoudeSend = async () => {
        setErrorMessage('')
        setCodesend(true)
        const url = Config.Lambda_weburl + 'verificationcode/send'
        const payload = {
            "type": 1,
            "reservationid": DigitalkeyData?.reservationid,
            "fullcontact": DigitalkeyData?.fullcontact || '',
            "propertyid": DigitalkeyData?.propertyid || '',
        }
        let { Result } = await API_Call('p', url, payload, {})
        if (Result.status === 200) {
            setErrorMessage('')
            setSuccess('OTP Sent Successfully')
            if (otpInputRefs[0].current) {
                setTimeout(() => {
                    otpInputRefs[0].current.focus();
                }, 300);
            }
        }
        else {
            setErrorMessage(Result.message)
            console.log('error')
        }
        setCodesend(false)
    }

    const VerifyCode = async () => {
        const otp = otpValues.join('');
        if (otp.length !== 4) {
            return;
        }
        setIsVerifying(true);
        try {
            const url = Config.Lambda_weburl + 'verificationcode/verify'
            const payload = {
                "reservationid": DigitalkeyData?.reservationid || '',
                "fullcontact": DigitalkeyData?.fullcontact || '',
                "propertyid": DigitalkeyData?.propertyid || '',
                "otp": otp,
            }
            let { Result } = await API_Call('p', url, payload, {})
            if (Result.status === 200) {
                setErrorMessage('');
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                for (const key of keys) {
                    await setAllStorageData('isOtpVerified', 1, key);
                }
                navigate(`/${getURLData().defaultURL}/unlockdoor`);
            }
            else {
                setErrorMessage(Result.message)
                setOtpValues(['', '', '', '']);
                // Focus on the first input block after error
                if (otpInputRefs[0].current) {
                    otpInputRefs[0].current.focus();
                }
            }
        }
        catch (error) {
            let ErrorData = error?.response?.data?.message
            setErrorMessage(ErrorData)
            setOtpValues(['', '', '', '']);
            // Focus on the first input block after error
            if (otpInputRefs[0].current) {
                otpInputRefs[0].current.focus();
            }
        }
        finally {
            setIsVerifying(false);
        }
    }

    return (
        <div className="digital-key-container">
            {/* Header */}
            <Header title="Digital Key" />

            <main className="sc-content">
                {/* Phone Icon */}
                <img src={phoneimage} alt="Phone Icon" className="icon" />

                {/* Message Text */}
                <p className="message mb-0">
                    {showOtp
                        ? "Enter the verification code sent to your registered mobile number"
                        : "We will send a verification code on your registered mobile number"}
                </p>

                {/* Masked Mobile Number */}
                <p className="mobile-number">
                    {(() => {
                        const phoneNumber = DigitalkeyData?.fullcontact || "";
                        const linkphoneNumber = getURLData().defaultURL.split("/").slice(1, 2).join("/");
                        if (!phoneNumber || !linkphoneNumber) return phoneNumber;
                        const countryCode = phoneNumber.replace(linkphoneNumber, "");
                        const lastFourDigits = linkphoneNumber.slice(-4);
                        const maskedPart = "*".repeat(linkphoneNumber.length - 4);
                        return `${countryCode}${maskedPart}${lastFourDigits}`;
                    })()}
                </p>

                {/* OTP Section */}
                {showOtp ? (
                    <>
                        <div className="otp-section">
                            {/* OTP Input Boxes */}
                            <div className="otp-boxes">
                                {Array.from({ length: 4 }, (_, index) => (
                                    <input
                                        key={index}
                                        type="tel"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        className="otp-input"
                                        name={`otp-${index}`}
                                        value={otpValues[index]}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        onPaste={handleOtpPaste}
                                        ref={otpInputRefs[index]}
                                        autoFocus={index === 0}
                                        disabled={isVerifying || codesend}
                                        autoComplete="one-time-code"
                                        data-form-type="other"
                                        data-otp-index={index}
                                        id={`otp-input-${index}`}
                                        enterKeyHint={index < 3 ? "next" : "done"}
                                    />
                                ))}
                            </div>

                            {/* Resend + Timer Section */}
                            <div className="resend-section">
                                <p className="resend-text">
                                    Didn’t receive yet?
                                    <span
                                        className="resend-link text-decoration-underline ml-1"
                                        onClick={() => {
                                            if (!isVerifying && !codesend) {
                                                handleResendClick();
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Resend Code
                                    </span>
                                </p>

                                {/* Error Message */}
                                {errorMessage && (
                                    <div className="error-box">
                                        <i className="material-icons-outlined error-icon">error_outline</i>
                                        <span>{errorMessage}</span>
                                    </div>
                                )}

                                {/* Countdown Timer */}
                                {showTimer && (
                                    <p className="timer-text">
                                        Your verification code will expire in{" "}
                                        <span className="timer">{timer}</span>
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="button-group mt-3">
                            <button
                                className={`cancel-button ${isVerifying || codesend ? "disable-button" : ""
                                    }`}
                                disabled={isVerifying || codesend}
                                onClick={() => {
                                    setShowOtp(false);
                                    setOtpValues(["", "", "", ""]); // Reset OTP values
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className={`verify-button ${isVerifying || codesend ? "disable-button" : ""
                                    }`}
                                id="verify-button"
                                onClick={() => VerifyCode(props)}
                                disabled={isVerifying || codesend}
                            >
                                {isVerifying ? "Verifying..." : "Verify"}
                            </button>
                        </div>
                    </>
                ) : (
                    // Initial Receive Code Button
                    <div
                        className="button-group"
                        onClick={() => {
                            setIsVerifying(false);
                            setShowOtp(true);
                            CoudeSend();
                            startCountdown();

                            setTimeout(() => {
                                otpInputRefs[0].current?.focus();
                            }, 300);
                        }}
                    >
                        <button className="receive-code-button">Receive Code</button>
                    </div>
                )}
            </main>

            {/* Success Message Overlay */}
            <SuccessOverlay
                show={success}
                message={success}
                onClose={() => setSuccess("")}
            />
        </div>
    );

};

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    setProps: (payload) => dispatch(setProps(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(VerifyOTP)
